import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Backoffice from '../backoffice';
import Design from '../design/DesignCondition';
import Home from '../home/Home';
import Info from '../info/Info';
import ErrorBoundary from './ErrorBoundary';
import NotFound from './NotFound';
import HelpDetail from '../backoffice/help/HelpDetail';
import Layout from '../layout/Index';
import Geometry from '../geometry/Geometry';
import ProductDetail from '../backoffice/product/ProductDetail';
import SoilDetail from '../backoffice/soil/SoilDetail';
import DrainPipeDetail from '../backoffice/drainPipe/DrainPipeDetail';
import ProjectTemplateDetail from '../backoffice/projectTemplate/ProjectTemplateDetail';

export const route = {
    notFound: '*',
    home: '/',
    info: '/info',
    geometry: '/info/geometry',
    design: '/info/geometry/design/:projectId',
    backoffice: '/backoffice',
    backofficeProduct: '/backoffice/product/:param',
    backofficeProjectTemplate: '/backoffice/projectTemplate/:param',
    backofficeSoil: '/backoffice/soil/:param',
    backofficeDrainPipe: '/backoffice/pipe/:param',
    backofficeDocument: '/backoffice/document/newDocument',
};

const createRoute = (path: string, element: React.ReactNode) => ({
    path,
    element,
    errorElement: <ErrorBoundary />,
});

export default createBrowserRouter([
    {
        element: <Layout />,
        children: [
            createRoute(route.home, <Home />),
            createRoute(route.info, <Info />),
            createRoute(route.geometry, <Geometry />),
            createRoute(route.design, <Design />),
            createRoute(route.notFound, <NotFound />),
            createRoute(route.backoffice, <Backoffice />),
            createRoute(route.backofficeProduct, <ProductDetail />),
            createRoute(route.backofficeProjectTemplate, <ProjectTemplateDetail />),
            createRoute(route.backofficeSoil, <SoilDetail />),
            createRoute(route.backofficeDrainPipe, <DrainPipeDetail />),
            createRoute(route.backofficeDocument, <HelpDetail />),
        ],
    },
]);

export const RouteProvider = RouterProvider;
